import ImageGallery from "react-image-gallery";
import { carouselImageData } from "../imageCollections";

import "../css/home.css"

export default function Home() {
  return (
    <div>
      <ImageGallery 
        items={carouselImageData}
        autoPlay={true}
        showThumbnails={false}
        showNav={false}
        showBullets={true}
        showFullscreenButton={false}
        showPlayButton={false}
      />
    </div>
  );
}
